import { render } from "./CoResident.vue?vue&type=template&id=f509b13c"
import script from "./CoResident.vue?vue&type=script&lang=js"
export * from "./CoResident.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__